<template>
  <div>
    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <h4 class="mt-4 mb-3 title-custom">
          Cambios solicitados: Cambio de descripción
        </h4>
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <ul class="nav nav-tabs justify-content-end" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="true"
            >
              Contratante
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact-tab-pane"
              type="button"
              role="tab"
              aria-controls="contact-tab-pane"
              aria-selected="false"
            >
              Mensajes
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabindex="0"
          >
            <h4 class="title-custom mt-4">Datos del contratante</h4>

            <div class="row mt-4">
              <div class="col-md-6">
                <p>
                  Nombre:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].NOMBRE
                  }}</span>
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  R.F.C:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].RFC
                  }}</span>
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  Situación fiscal:
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  Fecha de nacimiento:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].FECHANACIMIENTO
                  }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Dirección:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].DIRECCION
                  }}</span>
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  Numero Exterior:
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  Numero interior:
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  Código postal:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].CODIGOPOSTAL
                  }}</span>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Colonia:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].COLONIA
                  }}</span>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Alcaldía o Municipio:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].COLONIA
                  }}</span>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Estado:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].ESTADO
                  }}</span>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Telefóno:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].TELEFONO
                  }}</span>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Correo electronico:
                  <span class="label-custom-bold">{{
                    this.datosPoliza.ASEGURADO[0].CORREO
                  }}</span>
                </p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <hr />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-5">
                <p>
                  Nombre:
                  <input type="text" class="form-control" v-model="nombre" />
                </p>
              </div>
              <div class="col-md-3">
                <label class="font-label">R.F.C</label>
                <div class="input-group">
                  <input
                    type="text"
                    name="rfc"
                    class="form-control"
                    v-model="rfc"
                    maxlength="13"
                    @keypress="clsAlphaNoOnly"
                    required
                  />
                </div>
              </div>
              <div class="col-md-2">
                <p>
                  Situación fiscal:
                  <select class="form-control">
                    <option
                      v-for="(elem, i) in situacionElemento"
                      :key="i"
                      :value="elem.clave"
                    >
                      {{ elem.situacionElemento }}
                    </option>
                  </select>
                </p>
              </div>
              <div class="col-md-2">
                <label class="font-label"> Fecha de nacimiento:</label>
                <input
                  type="date"
                  name="fechaNacimiento"
                  v-model="fechaNacimiento"
                  class="form-control"
                  @keyup="validateBirthdate"
                  required
                />
                <small class="text-danger" v-if="errorBirthdate"
                >La edad no puede ser menor de 16 ni mayor a 90</small
              >
              </div>
              <div class="col-md-6">
                <p>
                  Dirección:
                  <input type="text" class="form-control" v-model="direccion" />
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  Numero Exterior:
                  <input
                    type="text"
                    class="form-control"
                    v-model="numExterior"
                  />
                </p>
              </div>
              <div class="col-md-2">
                <p>
                  Numero interior:
                  <input
                    type="text"
                    class="form-control"
                    v-model="numInterior"
                  />
                </p>
              </div>
              <div class="col-md-2">
                <label class="label-custom">Código postal</label>
                <input
                  type="number"
                  name="cp"
                  class="form-control"
                  @keyup="handleCP"
                  v-model="cp"
                  required
                />
                <small class="text-danger" v-if="malformedCP"
                  >Código postal incorrecto</small
                >
              </div>
              <div class="col-md-4">
                <p>
                  Colonia:
                  <input type="text" class="form-control" v-model="colonia" />
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Alcaldía o Municipio:
                  <input type="text" class="form-control" v-model="municipio" disabled />
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Estado:
                  <input type="text" class="form-control" v-model="estado" disabled />
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Telefóno:
                  <input type="text" class="form-control" v-model="telefono" />
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  Correo electronico:
                  <input type="text" class="form-control" v-model="correo" />
                </p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-8">
                <h6 class="title-custom mt-4">
                  Por favor revisa que toda la información sea correcta.
                </h6>
              </div>
              <div class="col-md-4 mt-4 d-flex justify-content-end">
                <button class="btn btn-primary btn-rounded" @click="guardarCambios">Enviar</button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="contact-tab-pane"
            role="tabpanel"
            aria-labelledby="contact-tab"
            tabindex="0"
          >
            <div class="row mt-4">
              <div class="col-md-8">
                <p>Mensaje de Suscripción:</p>
                <p>Se necesita más información para realizar la corrección.</p>
              </div>
              <div class="col-md-4">
                <p>Fecha</p>
                <p>24/08/2022</p>
              </div>
              <div class="col-md-12 mt-3">
                <textarea class="form-control" v-model="comentario"></textarea>
              </div>
              <div class="col-md-12 mt-4">
                <label
                  >Adjunta tus archivos aquí (formato .pdf)
                  <input type="file" class="ml-2" id="file" />
                </label>
              </div>
              <div class="col-md-12 mt-4 d-flex justify-content-end">
                <button
                  class="btn btn-primary btn-rounded"
                  @click="enviarArchivo"
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { format, convert } from "../../../../assets/helpers";

export default {
  props: {
    datosPoliza: Object,
    endoso: Object,
    altaFolioInnova: Function
  },
  data() {
    return {
      nombre: this.datosPoliza.ASEGURADO[0].NOMBRE,
      rfc: this.datosPoliza.ASEGURADO[0].RFC,
      situacionFiscal: "",
      fechaNacimiento:
        this.formatInputDate(
          new Date(
            format.date(
              this.datosPoliza.ASEGURADO[0].FECHANACIMIENTO,
              "aaaa/mm/dd"
            )
          ),
          0
        ) || "",
      direccion: this.datosPoliza.ASEGURADO[0].DIRECCION,
      numExterior: "",
      numInterior: "",
      cp: this.datosPoliza.ASEGURADO[0].CODIGOPOSTAL,
      colonia: this.datosPoliza.ASEGURADO[0].COLONIA,
      municipio: this.datosPoliza.ASEGURADO[0].POBLACION,
      estado: this.datosPoliza.ASEGURADO[0].ESTADO,
      telefono: this.datosPoliza.ASEGURADO[0].TELEFONO,
      correo: this.datosPoliza.ASEGURADO[0].CORREO,
      situacionElemento: [],
      delegacion: "",
      universe: "",
      universe2: "",
      malformedCP: false,
      comentario: "",
      archivos: [],
      errorBirthdate: false,
    };
  },
  methods: {
    async catSituacionFiscal() {
      const payload = {
        metodo: "COBRANZACONSULTACATALOGO",
        data: {
          pIdUsuario: localStorage.getItem("userId"),
          pOpcion: "SituacionElemento",
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.situacionElemento.push(...response);
      }
    },
    async getAddress() {
      if (this.estado) {
        return;
      }
      const payload = {
        metodo: "GET_CP_CA",
        data: {
          cp: this.cp,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const address = this.$store.getters.getRespuestaREST[0];

        if (address !== undefined) {
          this.estado = address.NombreEstado;
          this.municipio = address.NombreMunicpio;
          this.delegacion = address.NombreCiudad;
          this.universe = address.MunUniverse;
          this.universe2 = address.Universe;
        }
      }
    },
    guardarCambios() {

      if (this.errorBirthdate) {
        return this.$swal("Error", "La edad no puede ser menor de 16 ni mayor a 90");
      }

      this.$emit("update:endoso", {
        nombre: this.nombre,
        rfc: this.rfc,
        situacionFiscal: this.situacionFiscal,
        fechaNacimiento: this.fechaNacimiento,
        direccion: this.direccion,
        numExterior: this.numExterior,
        numInterior: this.numInterior,
        cp: this.cp,
        colonia: this.colonia,
        municipio: this.municipio,
        estado: this.estado,
        telefono: this.telefono,
        correo: this.correo
      })

      this.altaFolioInnova({}, "B3", "B", "");
    },
    async enviarArchivo() {
      const file = document.getElementById("file").files[0];

      if (file) {
        const promise = convert.convertFileToBase64(file);

        promise.then((result) => {
          this.altaFolioInnova(
            {
              base64: result,
              nombre: file.name,
              contentType: file.type,
              extension: "pdf",
            },
            "B1",
            "B",
            this.comentario
          );
        });
      }
    },
    handleCP(e) {
      const cp = e.target.value;
      this.estado = "";

      if (isNaN(cp)) {
        this.$swal.fire({
          title: "Sólo números son permitidos",
        });
        e.target.value = cp.slice(0, -1);
        return;
      }

      this.malformedCP = false;

      if (cp.length === 5) {
        this.cp = cp;
        this.getAddress();
      } else if (cp.length > 5) {
        this.malformedCP = true;
      }
    },
    formatInputDate(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    clsAlphaNoOnly(e) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$");
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (regex.test(str)) {
        return true;
      }

      e.preventDefault();
      return false;
    },
    validateBirthdate(e) {
      const edad = this.getAge(e.target.value);

      if (edad < 16 || edad > 90) {
        this.errorBirthdate = true;
        return false;
      }

      this.errorBirthdate = false;
      return true;
    },
    getAge(dateString) {
      const today = new Date();
      const birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
  },
  async mounted() {
    await this.catSituacionFiscal();
  },
};
</script>